module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-442ca5c2.png";